module.exports = __webpack_public_path__ + "img/场景管理.299c8dec.svg";